import { deepCopy } from "./common.service";
import set from "lodash/set";

export type UpdateDataFn<T> = (updater: (prevData: T[]) => T[]) => void;


/**
 * Adds a new row to the data array if the last row is not empty.
 */
export const addNewRow = <T>(prevData: T[], newRow: T, isRowEmpty: (row: T) => boolean): T[] => {
    const localData = deepCopy(prevData);
    const lastItem = localData[localData.length - 1];

    if (!lastItem || !isRowEmpty(lastItem)) {
        return [...localData, newRow];
    }
    return localData;
};


/**
 * Updates a specific field of a row in the data array (supports nested fields) 
 * and ensures a new row is added if needed.
 */
export const handleFormItemChange = <T>(
    setData: UpdateDataFn<T>,
    idx: number, 
    fieldPath: string, // Support for nested fields, e.g., "address.city"
    value: any, 
    newRow: T,
    isRowEmpty: (row: T) => boolean
) => {
    setData((prevData) => {
        const updatedData = deepCopy(prevData);

        if (updatedData[idx]) {
            set(updatedData[idx], fieldPath, value); // Dynamically update nested fields
        }

        return addNewRow(updatedData, newRow, isRowEmpty);
    });
};

